import { coreInitiativesByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesByIdGetAsyncSlice } from './get';
import { coreInitiativesByIdPatchAsyncSlice } from './patch';

export const { requestDeleteCoreInitiativesById, resetDeleteCoreInitiativesById } =
	coreInitiativesByIdDeleteAsyncSlice.asyncActionCreators;

export const { requestGetCoreInitiativesById, resetGetCoreInitiativesById } =
	coreInitiativesByIdGetAsyncSlice.asyncActionCreators;

export const { requestPatchCoreInitiativesById, resetPatchCoreInitiativesById } =
	coreInitiativesByIdPatchAsyncSlice.asyncActionCreators;
